'use strict';

const Modal = require('./Modal');
const Header = require('./Header');
const Body = require('./Body');

module.exports = { Modal, Header, Body };



// WEBPACK FOOTER //
// ./assets/js/global/views/modal/index.jsx